
export function authenticated(state) {
  return state.status.authenticated;
}
export function status(state) {
  return state.status.loading;
}
export function getUser(state) {
  return state.status.user;
}
export function loginError(state) {
  return state.loginError;
}
export function registrationError(state) {
  return state.registrationError;
}



